import { render, staticRenderFns } from "./BriqRadio.vue?vue&type=template&id=726910fc&scoped=true&lang=pug&"
import script from "./BriqRadio.vue?vue&type=script&lang=js&"
export * from "./BriqRadio.vue?vue&type=script&lang=js&"
import style0 from "./BriqRadio.vue?vue&type=style&index=0&id=726910fc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726910fc",
  null
  
)

export default component.exports